var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 16,
    viewBox: "0 0 6 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M.625-.75H1.25v-4.5H.625a.6.6,0,0,1-.437-.187A.6.6,0,0,1,0-5.875v-1.5a.6.6,0,0,1,.188-.437A.6.6,0,0,1,.625-8h3.5a.6.6,0,0,1,.438.188.6.6,0,0,1,.188.438V-.75h.625a.6.6,0,0,1,.438.188A.6.6,0,0,1,6-.125v1.5a.6.6,0,0,1-.187.438A.6.6,0,0,1,5.375,2H.625a.6.6,0,0,1-.437-.187A.6.6,0,0,1,0,1.375v-1.5A.6.6,0,0,1,.188-.562.6.6,0,0,1,.625-.75Zm.781-12.594A2.17,2.17,0,0,1,3-14a2.17,2.17,0,0,1,1.594.656A2.17,2.17,0,0,1,5.25-11.75a2.17,2.17,0,0,1-.656,1.594A2.17,2.17,0,0,1,3-9.5a2.17,2.17,0,0,1-1.594-.656A2.17,2.17,0,0,1,.75-11.75,2.17,2.17,0,0,1,1.406-13.344Z",
    transform: "translate(0 14)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.adacac0bec6f2f211c7d2d737f36cbb6.svg";
export { ForwardRef as ReactComponent };